import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { listAllClassAttendance, studentlistAttendance, classSecitionList } from "../../../services/attendance";
import { Col, Modal, Row } from "react-bootstrap";
import { roleList, stuclasslist, studivisionlist } from "../../../services/master";
import moment from "moment";
import { academylist, listclassAttendance } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { studentviewdetail } from "../../../services/student";
import { useLocation } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { smslist } from "../../../services/common";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

function buildClassChartFromMerged(classData) {
  if (!classData || classData.length === 0) return null;
  return {
    labels: classData.map(c => `${c.class_name}${c.section_name ? ' - ' + c.section_name : ''}`),
    datasets: [
      { label: 'Present', data: classData.map(c => c.present), backgroundColor: 'rgba(25,177,89,0.85)' },
      { label: 'Absent', data: classData.map(c => c.absent), backgroundColor: 'rgba(241,109,117,0.85)' },
    ],
  };
}

function buildDateChart(data) {
  if (!data || data.length === 0) return null;
  const grouped = {};
  data.forEach(item => {
    const key = item.att_date || 'N/A';
    if (!grouped[key]) grouped[key] = { total: 0, present: 0, absent: 0 };
    grouped[key].total += (item.total_students || 0);
    grouped[key].present += (item.morning_present || 0) + (item.afternoon_present || 0);
    grouped[key].absent += (item.morning_absent || 0) + (item.afternoon_absent || 0);
  });
  if (Object.keys(grouped).length === 0) return null;
  return {
    labels: Object.keys(grouped),
    datasets: [
      { label: 'Total', data: Object.values(grouped).map(v => v.total), backgroundColor: 'rgba(98,89,202,0.8)' },
      { label: 'Present', data: Object.values(grouped).map(v => v.present), backgroundColor: 'rgba(25,177,89,0.85)' },
      { label: 'Absent', data: Object.values(grouped).map(v => v.absent), backgroundColor: 'rgba(241,109,117,0.85)' },
    ],
  };
}

const CLASS_CHART_OPTIONS = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    datalabels: {
      color: '#fff',
      anchor: 'end',
      align: 'start',
      font: { weight: 'bold', size: 12 },
      formatter: (value) => String(value),
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      title: { display: true, text: 'Count', color: '#666', font: { size: 13, weight: 'bold' } },
    },
    y: {
      title: { display: true, text: 'Class', color: '#666', font: { size: 13, weight: 'bold' } },
    },
  },
};

const DATE_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    datalabels: {
      color: '#fff',
      anchor: 'end',
      align: 'start',
      font: { weight: 'bold', size: 11 },
      formatter: (value) => String(value),
    },
  },
  scales: {
    x: {
      title: { display: true, text: 'Date', color: '#666', font: { size: 13, weight: 'bold' } },
    },
    y: {
      beginAtZero: true,
      title: { display: true, text: 'Count', color: '#666', font: { size: 13, weight: 'bold' } },
    },
  },
};

function AttendanceChart({ data, classData, toDate }) {
  const classChart = buildClassChartFromMerged(classData);
  const dateChart = buildDateChart(data);
  if (!classChart && !dateChart) return null;
  return (
    <>
      {classChart && (
        <div className="col-sm-12 mt-4">
          <div className="card custom-card">
            <div className="card-body">
              <div className="text-center mb-3">
                <h5 style={{ fontWeight: 'bold', margin: 0 }}>Student Strength Analysis{toDate ? ' (' + moment(toDate, 'YYYY-MM-DD').format('DD-MM-YYYY') + ')' : ''}</h5>
                <p className="text-muted tx-12 mb-0">Class Wise — Present &amp; Absent</p>
              </div>
              <div style={{ height: Math.max(300, classChart.labels.length * 55) + 'px', width: '100%' }}>
                <Bar data={classChart} options={CLASS_CHART_OPTIONS} />
              </div>
            </div>
          </div>
        </div>
      )}
      {dateChart && (
        <div className="col-sm-12 mt-4">
          <div className="card custom-card">
            <div className="card-body">
              <div className="text-center mb-3">
                <h5 style={{ fontWeight: 'bold', margin: 0 }}>Student Strength Analysis</h5>
                <p className="text-muted tx-12 mb-0">Date Wise — Total, Present &amp; Absent</p>
              </div>
              <div style={{ height: Math.max(300, dateChart.labels.length * 45) + 'px', width: '100%' }}>
                <Bar data={dateChart} options={DATE_CHART_OPTIONS} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function Allattendance() {
  const [attendanceData, setAttendanceData] = useState([]);
  const [classChartRows, setClassChartRows] = useState([]);

  const [cdate, setCDate] = useState("");
  const [todate, setToDate] = useState("");

  const [cclass, setCClass] = useState(0);
  const [clist, setCList] = useState([]);

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [wlist, setWlist] = useState([]);
  const [wtype, setWType] = useState(4);

  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");
  const [slist, setSlist] = useState([]);
  const [stusec, setStuSec] = useState("");

  const [urllink, setUrl] = useState("");
  const location = useLocation();

  function loadClassChart(date, aca) {
    Promise.all([
      classSecitionList(aca || 0),
      listAllClassAttendance(date, date, 0, aca || 0, 4),
    ]).then(([secRes, attRes]) => {
      const allSecs = secRes && secRes.status === true ? secRes.data : [];
      const attMap = {};
      if (attRes && attRes.status === true) {
        attRes.data.forEach(item => {
          const key = item.class_name + '||' + item.section_name;
          const morning = item.TimeStatus.find(t => t.Time === 'Morning') || {};
          // Second slot accepts both legacy "Afternoon" and current "Evening".
          const afternoon = item.TimeStatus.find(t => t.Time === 'Afternoon' || t.Time === 'Evening') || {};
          attMap[key] = {
            present: (morning.present_count || 0) + (afternoon.present_count || 0),
            absent: (morning.absent_count || 0) + (afternoon.absent_count || 0),
            total: item.total_students || 0,
          };
        });
      }
      const merged = allSecs.map(sec => {
        const key = sec.class_name + '||' + sec.section_name;
        const att = attMap[key];
        return {
          class_name: sec.class_name,
          section_name: sec.section_name,
          present: att ? att.present : 0,
          absent: att ? att.absent : (sec.total_students || 0),
          total: att ? att.total : (sec.total_students || 0),
        };
      });
      setClassChartRows(merged);
    });
  }

  useEffect(() => {
    if (!todate || urllink !== "allattendance") return;
    const aca = localStorage.getItem("Role") == 1
      ? (acaid !== "" ? acaid.value : 0)
      : (localStorage.getItem("academy") || 0);
    loadClassChart(todate, aca);
  }, [todate, acaid, urllink]);

  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrl(path);
    roleList().then((res) => {
      if (res.status === true) {
        setWlist(res.data);
      }
    });
    if (path === "attendancereport") {
      if (localStorage.getItem("ADate") !== '') {
        setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        listattrep(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), 0, 0, 0, 0);

      } else {
        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
        listattrep(moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 0, 0, 0, 0);

      }

      stuclasslist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].class_name,
              });
            }
            setCList(arr);
          }
        }
      });

      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setAList(arr);
          }
        }
      });

      studivisionlist().then((res) => {
        if (res.status === true) {
          setSlist(res.data);
        }
      })
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                }
              }

            }
          }
        });
      }
    } else {
      if (localStorage.getItem("Role") == 4) {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        studentviewdetail(localStorage.getItem("UID")).then((res) => {
          if (res.status === true && res.data.details !== null) {
            setCClass(res.data.details.class_id);
            setAcaID(res.data.details.academy_id);

            fetchAttendance(formatDate(firstDay), formatDate(lastDay), res.data.details.class_id, res.data.details.academy_id);
          }
        })
      } else {
        if (localStorage.getItem("ADate") !== '') {
          setCDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
          setToDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
        } else {
          setCDate(moment(new Date()).format("YYYY-MM-DD"));
          setToDate(moment(new Date()).format("YYYY-MM-DD"));
        }

        stuclasslist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                arr.push({
                  value: res.data[i].id,
                  label: res.data[i].class_name,
                });
              }
              setCList(arr);
            }
          }
        });

        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              setAList(arr);
            }
          }
        });

        if (localStorage.getItem("AAcademy") != null) {
          academylist().then((res) => {
            if (res.status === true) {
              let arr = [];
              if (res.data.details.length > 0) {
                for (let i = 0; i < res.data.details.length; i++) {
                  if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                    arr.push({
                      value: res.data.details[i].id,
                      label:
                        res.data.details[i].name + " - " + res.data.details[i].code,
                    });
                  }
                  if (arr.length > 0) {
                    setAcaID(arr[0]);

                  }
                }

              }
            }
          });
        }

        if (localStorage.getItem("ADate") !== '') {
          listall(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), 0, 0, 0);
        } else {
          listall(moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 0, 0, 0);

        }

        if (localStorage.getItem("Role") >= 5) {
          const today = new Date();
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fetchAttendance(formatDate(firstDay), formatDate(lastDay), 0, localStorage.getItem("academy"));
        }
      }
    }


  }, [location.pathname]);

  function listall(ldate, tdte, lcls, laca, lrole) {
    if (ldate && tdte && tdte < ldate) {
      toast.error("To Date should not be less than From Date.");
      return;
    }
    setCDate(ldate);
    setToDate(tdte);
    setCClass(lcls);
    let aca = 0;
    if (laca !== 0) {
      aca = laca.value;
    }
    if (localStorage.getItem("Role") == 4) {
      lrole = localStorage.getItem("Role");
      aca = localStorage.getItem("academy");
    } else if (localStorage.getItem("Role") == 5) {
      lrole = 4;
      aca = localStorage.getItem("academy");
    }
    listAllClassAttendance(ldate, tdte, lcls, aca, lrole).then((res) => {
      if (res.status === true) {
        setLoading(false);
        const transformedData = res.data.map(item => {
          const morningStatus = item.TimeStatus.find(t => t.Time === 'Morning') || {};
          // Second slot accepts both legacy "Afternoon" and current "Evening".
          const afternoonStatus = item.TimeStatus.find(t => t.Time === 'Afternoon' || t.Time === 'Evening') || {};

          return {
            academic_year: item.academic_year,
            att_date: moment(item.date).format("DD-MM-YYYY"),
            class_name: item.class_name,
            section_name: item.section_name,
            academy_name: item.academy_name,
            total_students: item.total_students,
            morning_present: morningStatus.present_count || 0,
            morning_absent: morningStatus.absent_count || 0,
            afternoon_present: afternoonStatus.present_count || 0,
            afternoon_absent: afternoonStatus.absent_count || 0,
            all_list: item.AllList
          };
        });
        setAttendanceData(transformedData);
        // setAttendanceData(res.data);

      } else {
        setLoading(false);
        toast.error(res.message);
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      if (urllink === "attendancereport") {
        listattrep(fdate, tdate, cclass, e, wtype, stusec);
      } else {
        listall(cdate, todate, cclass, e, wtype);
      }
    } else {
      setAcaID("");
      if (urllink === "attendancereport") {
        listattrep(fdate, tdate, cclass, "", wtype, stusec);
      } else {
        listall(cdate, todate, cclass, "", wtype);
      }
    }
  }
  const [loading, setLoading] = useState(false);

  const [events, setEvents] = useState([]);
  const formatDate = (date) => {
    return date.toISOString().split("T")[0].split("-").reverse().join("-");
  };

  const fetchAttendance = (startDate, endDate, lcls, aca) => {
    const formattedStartDate = convertToISO(startDate);
    const formattedEndDate = convertToISO(endDate);
    const allAttendance = [];


    studentlistAttendance(startDate, endDate, lcls, aca, localStorage.getItem("UID")).then((res) => {
      if (res.status === true) {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            const event = {
              title: `${item.attend_status === 1 ? item.attendance_time + " - Present" : item.attendance_time + " - Absent"}`,
              start: item.attendance_date,
              backgroundColor: item.attend_status === 1 ? "green" : "red"
            };

            allAttendance.push(event);
          });
          // const filteredEvents = allAttendance.filter((event) => {
          //   return event.start >= formattedStartDate && event.start <= formattedEndDate;
          // });

          setEvents(allAttendance);
        }

      } else {
        toast.error(res.message);
      }
    });
  };
  const convertToISO = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };
  // Load current month's data on first render
  const [filterProduct, setFilterProduct] = useState([]);

  function listattrep(fdte, tdte, lcls, laca, lrole, lsec) {
    if (fdte && tdte && tdte < fdte) {
      toast.error("To Date should not be less than From Date.");
      return;
    }
    setFDate(fdte);
    setTDate(tdte);
    setCClass(lcls);
    setStuSec(lsec);
    let aca = 0;
    if (laca !== 0 && localStorage.getItem("Role") == 1) {
      aca = laca.value;
    } else if (localStorage.getItem("Role") !== "1") {
      aca = localStorage.getItem("academy")
    }
    listclassAttendance(fdte, tdte, lcls, aca, lrole, lsec).then((res) => {
      if (res.status === true) {
        setLoading(false);
        const mappedData = res.data.map(item => {
          const morning = item.TimeStatus.find(time => time.Time === "Morning");
          // Evening slot accepts both current "Evening" and legacy "Afternoon".
          const evening = item.TimeStatus.find(time => time.Time === "Evening" || time.Time === "Afternoon");

          return {
            ...item,
            att_date: moment(item.date).format("DD-MM-YYYY"),
            morning_present: morning ? morning.present_count : 0,
            morning_absent: morning ? morning.absent_count : 0,
            evening_present: evening ? evening.present_count : 0,
            evening_absent: evening ? evening.absent_count : 0,
          };
        });
        setFilterProduct(mappedData);
      } else {
        setLoading(false);
        toast.error(res.message);
      }
    });
  }
  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "academic_year_id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        if (urllink === "attendancereport") {
          return (
            <div className="text-center">
              <a
                title="Download Attendance Report"
                onClick={() => downloadreport(params.data)}
                className="btn-sm btn-success"
              >
                <i className="fas fa-download"></i>
              </a>
            </div>
          );
        } else {
          return (
            <div className="text-center">
              <a
                title="View Attendance List"
                onClick={() => viewreport(params.data, params.rowIndex)}
                className="btn-sm btn-secondary"
              >
                <i className="fa fa-list"></i>
              </a>
            </div>
          );
        }

      }
    },
    {
      headerName: "Academic Year",
      field: "academic_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      hide: wtype > 5,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "att_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      hide: wtype > 4,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      hide: wtype > 4,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Total",
      field: "total_students",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Morning Present",
      field: "morning_present",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Morning Absent",
      field: "morning_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Evening Present",
      field: "evening_present",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Evening Absent",
      field: "evening_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },


  ];

  const columnTDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "academic_year_id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        return (
          <div className="text-center">
            <a
              title="Download Attendance Report"
              onClick={() => downloadreport(params.data)}
              className="btn-sm btn-success"
            >
              <i className="fas fa-download"></i>
            </a>
          </div>
        );
      }
    },
    {
      headerName: "Academic Year",
      field: "academic_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "att_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Total",
      field: "total_students",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Morning Present",
      field: "morning_present",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Morning Absent",
      field: "morning_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Evening Present",
      field: "evening_present",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Evening Absent",
      field: "evening_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },


  ];

  const columnSDefs = [
    {
      headerName: "Action",
      field: "user_id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        return (
          <div className="text-center">
            <a
              title="Send SMS" onClick={() => sendsms(params.data)}
              className="btn-sm btn-success"
            >
              <i className="fas fa-sms"></i>
            </a>
          </div>
        );
      }
    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "attendance_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Morning Present",
      field: "morning_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Morning Absent",
      field: "evening_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function sendsms(rdata) {
    if (rdata.morning_status == "Absent" || rdata.evening_status == "Absent") {
      const msg = `Dear Parent, ${rdata.student_name} is absent on ${rdata.attendance_date}. Kindly send leave letter with your ward - ${sdata.academy_name}. AMYTEC`;
      const temp1 = new FormData();
      temp1.append("template_id", "1707176353727142911");
      temp1.append("academy_id", localStorage.getItem("AAcademy"));
      temp1.append("role_id", 4);
      temp1.append("class_id", '');
      temp1.append("section", '');
      temp1.append("emp_id", rdata.user_id);
      temp1.append("type", "indattendance");
      temp1.append("date", rdata.attendance_date);
      temp1.append("message", msg);
      // temp1.append("message", "Dear Parent, {#var#} is absent on {#var#}. Kindly send leave letter with your ward - {#var#}. AMYTEC");

      smslist(temp1).then((res) => {
        if (res.status === true) {
          toast.success(res.message);
        }
      })
    }
  }
  function downloadreport(rdata) {
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        valid = "Please Select Academy";
        toast.error(valid);
        return
      }
    }
    let aca = ''
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      aca = acaid.value
    } else if (localStorage.getItem("Role") !== "1") {
      aca = localStorage.getItem("academy")
    }
    const dte = moment(rdata.date).format("YYYY-MM-DD")
    const reportUrl = localStorage.getItem("reportUrl");
    window.open(reportUrl + 'report/attendanceexcel?academy_id=' + aca + '&date=' + dte + '&class_id=' + rdata.class_id + '&section_id=' + rdata.section_id + '&year_id=' + rdata.academic_year_id + '&role_id=' + wtype, "_blank");

  }
  const [show, setShow] = useState(false);
  const [alldata, setAlldata] = useState([]);
  const [sdata, setSdata] = useState("");

  function viewreport(lrdata, rid) {
    const rdata = attendanceData[rid];
    console.log(attendanceData);
    if (rdata.all_list.length > 0) {
      rdata.all_list = rdata.all_list.map((item) => {
        const morningValue =
          item.morning_status === 1 || item.morning_status === "1" ? 1 :
            item.morning_status === 0 || item.morning_status === "0" ? 0 :
              item.morning_status === "Present" ? 1 :
                item.morning_status === "Absent" ? 0 : null;

        const eveningValue =
          item.evening_status === 1 || item.evening_status === "1" ? 1 :
            item.evening_status === 0 || item.evening_status === "0" ? 0 :
              item.evening_status === "Present" ? 1 :
                item.evening_status === "Absent" ? 0 : null;

        return {
          ...item,
          attendance_date: rdata.att_date,
          morning_status:
            morningValue === 1 ? "Present" :
              morningValue === 0 ? "Absent" : "",
          // item.morning_status === 1 
          //   ? "Present"
          //   : item.morning_status === 0 
          //     ? "Absent"
          //     : "",
          evening_status:
            eveningValue === 1 ? "Present" :
              eveningValue === 0 ? "Absent" : "",
          // item.evening_status === 1 
          //   ? "Present"
          //   : item.evening_status === 0 
          //     ? "Absent"
          //     : ""
        };
      });
    }
    setSdata(rdata);
    setAlldata(rdata.all_list);
    setShow(true);
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "allattendance" ? "All Attendance" : "Attendance Report"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{urllink === "allattendance" ? "Attendance" : "Reports"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "allattendance" ? "All Attendance" : "Attendance Report"}
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && localStorage.getItem("Role") < 6 && urllink === "allattendance" && (
        <>
          {/* <Card className="custom-card overflow-hidden">
        <Card.Body> */}
          <Row className="row-sm mx-0">
            {localStorage.getItem("Role") == 1 && (
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">Filter by Academy</label>
                <Select
                  className="default-select"
                  placeholder="Select Academy"
                  value={acaid}
                  options={alist}
                  onChange={handleAcademy}
                  isSearchable={true}
                  isClearable
                  hidden
                />
              </Col>
            )}
            {localStorage.getItem("Role") < 3 &&
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={cdate}
                  onChange={(e) => listall(e.target.value, todate, cclass, acaid, wtype)}
                />
              </Col>
            }
            {localStorage.getItem("Role") < 3 &&
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={todate}
                  onChange={(e) => listall(cdate, e.target.value, cclass, acaid, wtype)}
                />
              </Col>
            }

            {localStorage.getItem("Role") < 3 &&
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">Role</label>
                <select
                  className="default-select form-control wide"
                  value={wtype}
                  onChange={(e) => { setWType(e.target.value); listall(cdate, todate, cclass, acaid, e.target.value) }}
                >
                  <option value={0} disabled>
                    Select Role
                  </option>
                  {localStorage.getItem("Role") != 5 &&
                    <>
                      {wlist
                        .filter(item => item.id > 3)
                        .map((item) => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                    </>
                  }
                  {localStorage.getItem("Role") == 5 &&
                    <>
                      {wlist
                        .filter(item => item.id === 4)
                        .map((item) => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                    </>
                  }


                </select>
              </Col>
            }


            {wtype == 4 &&
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">Filter by Class</label>
                <select
                  className="form-control"
                  onChange={(e) => listall(cdate, todate, e.target.value, acaid, wtype)}
                  value={cclass}
                >
                  <option value={0} disabled>
                    Select Class
                  </option>
                  {clist.map((classItem, i) => (
                    <option value={classItem.value} key={i}>
                      {classItem.label}
                    </option>
                  ))}
                </select>
              </Col>
            }

          </Row>
          {/* </Card.Body>
      </Card> */}
          {localStorage.getItem("Role") < 3 &&
            <div className="row row-sm">

              {/* {attendanceData.length === 0 && (
                <div className="col-sm-12 col-lg-12 col-xl-12">
                  <h5 className="text-center text-danger">No Attendance Found</h5>
                </div>
              )} */}
              {/* {attendanceData.length !== 0 && */}
              <div className="col-sm-12 col-lg-12 col-xl-12">
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={attendanceData}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
                {/* {attendanceData.map((attendance, index) => (
                  <div className="row row-sm" >
                    <div className="col-xl-12 col-md-12" key={index}>
                      <h3 className="text-center text-success">
                        {attendance.academy_name}
                      </h3>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <div className="card custom-card">
                        <div className="card-bodyy">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="product-content">
                                <h3 className="title">
                                  <a>
                                    {attendance.class_name}{" "}
                                    {attendance.section_name}
                                  </a>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                          {attendance.TimeStatus.map((timeStatus, idx) => (
                            <>
                              <div
                                className="col-md-12 col justify-content-center text-center"
                                key={idx}
                              >
                                <h3 className="mb-1 font-weight-bold">
                                  <p className="text-danger">
                                    {timeStatus.Time}
                                  </p>
                                </h3>
                              </div>
                              <div className="col-md-4 col justify-content-center text-center">
                                <h3 className="mb-1 font-weight-bold">
                                  <a>{attendance.total_students}</a>{" "}
                                  <p className="text-muted ">Total</p>
                                </h3>
                              </div>
                              <div className="col-md-4 col justify-content-center text-center">
                                <h3 className="mb-1 font-weight-bold">
                                  <a>{timeStatus.present_count}</a>{" "}
                                  <p className="text-muted ">Present</p>
                                </h3>
                              </div>
                              <div className="col-md-4 col justify-content-center text-center">
                                <h3 className="mb-1 font-weight-bold">
                                  <a>{timeStatus.absent_count}</a>{" "}
                                  <p className="text-muted ">Absent</p>
                                </h3>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))} */}
              </div>
              {/* } */}
              <AttendanceChart data={attendanceData} classData={classChartRows} toDate={todate} />
            </div>}


        </>
      )}

      <Modal size="lg" show={show}>
        <Modal.Header>
          <h4>
            <span>Attendance List</span>
          </h4>
        </Modal.Header>
        <Modal.Body>

          <div className="ag-theme-alpine ag-style">
            <AgGridReact
              columnDefs={columnSDefs}
              rowData={alldata}
              pagination="true"
              paginationPageSize="10"
              sortingOrder={["asc", "desc"]}
              suppressDragLeaveHidesColumns={true}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-next btn-secondary"
            style={{ float: "right" }}
            onClick={() => setShow(false)}
          >
            Close
          </a>
        </Modal.Footer>
      </Modal>

      {!loading && (localStorage.getItem("Role") == 4 || localStorage.getItem("Role") > 5) && urllink === "allattendance" && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  datesSet={(dateInfo) => {
                    const start = dateInfo.start.toISOString().split("T")[0];

                    const endDate = new Date(dateInfo.end);
                    endDate.setDate(endDate.getDate() - 1);
                    const end = endDate.toISOString().split("T")[0];

                    fetchAttendance(start, end, cclass, localStorage.getItem("academy"));
                  }}

                />
              </div>
            </div>
          </div>
        </div>

      )}

      {!loading && localStorage.getItem("Role") == 5 && urllink === "allattendance" && (
        <>
          <hr />
          <div className="content-body">
            <div className="container-fluid">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title text-white">My Attendance</h4>
                </div>
                <div className="card-body">
                  <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={events}
                    datesSet={(dateInfo) => {
                      const start = dateInfo.start.toISOString().split("T")[0];

                      const endDate = new Date(dateInfo.end);
                      endDate.setDate(endDate.getDate() - 1);
                      const end = endDate.toISOString().split("T")[0];

                      fetchAttendance(start, end, 0, localStorage.getItem("academy"));
                    }}

                  />
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title text-white">Student Attendance</h4>
                </div>
                <div className="card-body">
                  <div className="row row-sm">
                    <Col xxl={3} lg={3} md={3}>
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={cdate}
                        onChange={(e) => listall(e.target.value, todate, cclass, localStorage.getItem("academy"), 4)}
                      />
                    </Col>
                    <Col xxl={3} lg={3} md={3}>
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={todate}
                        onChange={(e) => listall(cdate, e.target.value, cclass, localStorage.getItem("academy"), 4)}
                      />
                    </Col>
                    <Col xxl={3} lg={3} md={3}>
                      <label className="form-label">Filter by Class</label>
                      <select
                        className="form-control"
                        onChange={(e) => listall(cdate, todate, e.target.value, localStorage.getItem("academy"), 4)}
                        value={cclass}
                      >
                        <option value={0} disabled>
                          Select Class
                        </option>
                        {clist.map((classItem, i) => (
                          <option value={classItem.value} key={i}>
                            {classItem.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <div className="col-sm-12 col-lg-12 col-xl-12">
                      <div className="ag-theme-alpine ag-style">
                        <AgGridReact
                          columnDefs={columnDefs}
                          rowData={attendanceData}
                          pagination="true"
                          paginationPageSize="10"
                          sortingOrder={["asc", "desc"]}
                          suppressDragLeaveHidesColumns={true}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <AttendanceChart data={attendanceData} classData={classChartRows} toDate={todate} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </>
      )}

      {!loading && urllink === "attendancereport" && (
        <>
          <Row className="row-sm mx-0">
            {localStorage.getItem("Role") == 1 && (
              <Col xxl={3} lg={3} md={3}>
                <label className="form-label">Filter by Academy</label>
                <Select
                  className="default-select"
                  placeholder="Select Academy"
                  value={acaid}
                  options={alist}
                  onChange={handleAcademy}
                  isSearchable={true}
                  isClearable
                  hidden
                />
              </Col>
            )}
            <Col xxl={3} lg={3} md={3}>
              <label className="form-label">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fdate}
                onChange={(e) => listattrep(e.target.value, tdate, cclass, acaid, wtype, stusec)}
              />
            </Col>
            <Col xxl={3} lg={3} md={3}>
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                value={tdate}
                onChange={(e) => listattrep(fdate, e.target.value, cclass, acaid, wtype, stusec)}
              />
            </Col>

            <Col xxl={3} lg={3} md={3}>
              <label className="form-label">Role</label>
              <select
                className="default-select form-control wide"
                value={wtype}
                onChange={(e) => { setWType(e.target.value); listattrep(fdate, tdate, cclass, acaid, e.target.value, stusec) }}
              >
                <option value={0} disabled>
                  Select Role
                </option>
                {localStorage.getItem("Role") != 5 &&
                  <>
                    {wlist
                      .filter(item => item.id > 3)
                      .map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </>
                }
                {localStorage.getItem("Role") == 5 &&
                  <>
                    {wlist
                      .filter(item => item.id === 4)
                      .map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </>
                }


              </select>
            </Col>
            {wtype == 4 &&
              <>
                <Col xxl={3} lg={3} md={3}>
                  <label className="form-label">Class</label>
                  <select
                    className="form-control"
                    onChange={(e) => listattrep(fdate, tdate, e.target.value, acaid, wtype, stusec)}
                    value={cclass}
                  >
                    <option value={0} disabled>
                      Select Class
                    </option>
                    {clist.map((classItem, i) => (
                      <option value={classItem.value} key={i}>
                        {classItem.label}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xxl={3} lg={3} md={3}>
                  <label className="form-label">Section</label>
                  <select
                    className="form-control"
                    onChange={(e) => listattrep(fdate, tdate, cclass, acaid, wtype, e.target.value)}
                    value={stusec}
                  >
                    <option value={0} disabled>
                      Select Section
                    </option>
                    {slist.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </Col>
              </>
            }

          </Row>

          <div className="ag-theme-alpine ag-style mt-2">
            <AgGridReact
              columnDefs={wtype == 4 ? columnDefs : columnTDefs}
              rowData={filterProduct}
              pagination="true"
              paginationPageSize="10"
              sortingOrder={["asc", "desc"]}
              suppressDragLeaveHidesColumns={true}
            />
          </div>

          <AttendanceChart data={filterProduct} classData={classChartRows} toDate={todate} />

        </>
      )}
    </div>
  );
}
